import settings from "../../settings";

export const printContent = (title, divId) => {
  let content = document.getElementById("uiRoot").innerHTML;
  if (divId && divId !== "") content = document.getElementById(divId).innerHTML;
  const printTitle = `${settings.appName.charAt(0).toUpperCase() +
    settings.appName.slice(1)} ${title}`;
  const mywindow = window.open("", printTitle, "height=600,width=800");

  mywindow.document.write(
    `<!DOCTYPE html><html><head><title>${printTitle}</title>`
  );
  mywindow.document.write(
    `<style>.no-print{display: none;} 
     </style>`
  );
  mywindow.document.write(
    `<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" />`
  );
  mywindow.document.write(
    `<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/semantic-ui@2.4.2/dist/semantic.min.css" />`
  );
  mywindow.document.write(
    `<link rel="stylesheet" type="text/css" href="/bootstrap-table-extra.css">`
  );
  mywindow.document.write(
    `<link rel="stylesheet" type="text/css" href="/App.css">`
  );
  mywindow.document.write(
    `<link rel="stylesheet" type="text/css" href="/main.css">`
  );
  mywindow.document.write(
    `<link rel="stylesheet" type="text/css" href="/print-media.css">`
  );
  mywindow.document.write(
    `<link rel="stylesheet" type="text/css" href="/sub-table.css">`
  );
  mywindow.document.write("</head><body>");
  mywindow.document.write(content);
  mywindow.document.write("</body></html>");

  mywindow.document.close();
  mywindow.focus();
  mywindow.onload = () => {
    setTimeout(() => {
      mywindow.print();
      mywindow.close();
    }, 1000);
  };
};

export default printContent;



// WEBPACK FOOTER //
// ./src/components/common/PrintContent.js